import { render, staticRenderFns } from "./addCatmastervalue.vue?vue&type=template&id=b3aa1e14"
import script from "./addCatmastervalue.vue?vue&type=script&lang=js"
export * from "./addCatmastervalue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports